import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
    fullWidth: {
        width: '100%',
        zIndex: 10,
      },
      root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        scrollbarWidth: 'none',
      },
      rootHeader: {
        display: 'flex',
        alignItems: 'center',
        height: 34,
        padding: '13px 19px',
        backgroundColor: 'rgb(41, 87, 255)',
        borderBottom: `4px solid rgb(255, 240, 0)`,
        left: 0,
        top: 0,
        zIndex: 100,
      },
      logo: {
        width: 40,
        marginRight: 12,
      },
      logoText: {
        color: 'rgb(255, 240, 0)',
        fontFamily: 'BancoDoBrasil Titulos',
        fontSize: 18,
        fontWeight: 'bold',
        marginRight: 16,
      },
      logoArea: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        border: 0,
      },
      logoBorder: {
        borderRight: 'solid 1px rgba(38, 38, 38, 0.25)',
      },
      body: {
        padding: '22px',
        overflow: 'auto',
        width: '464px'
      },
      clearButton:{
        background: 'none',
        color: '#2957FF',
        border: 'none',
        padding: '0',
        cursor: 'pointer',
        outline: 'inherit'
      },
      clearButton1:{
        background: 'none',
        color: 'white',
        border: 'none',
        padding: '0',
        cursor: 'pointer',
        outline: 'inherit'
      },
      input: {
        padding: 20,
        height: 40,
        width: "100%",
        boxSizing: "border-box",
        fontSize: 18,
        fontWeight: 500,
        fontFamily: "BancoDoBrasilTextos-Regular",
        outline: "none",
        border: "none",
        background: "rgba(0,0,0,0.05)",
        color: "rgba(0,0,0,0.50)",
        borderRadius: '4px 4px 0 0',
        borderBottom: '1px solid #B4B9C1'
      },
}));

export default useStyles;
